/**
 * Date: 2020-12-22 10:15:48
 * description: 声明配置导出
 *  @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import YxIncrementForm from "./incrementForm";
import PropTypes from "prop-types";

// 表单类型
let formType = [
  "Number",
  "String",
  "TextInput",
  "Date",
  "Password",
  "Phone",
  "Certificates",
  "Select",
  "TreeSelect",
  "EMail",
  "Url",
  "Range",
  "Cascader",
  "Radio",
  "Switch",
  "TextArea",
  "Upload",
  "Checkbox",
  "KindEditor",
  "Search",
  "YxPopup",
  "Extend",
  "ColorPicker",
  "IncrementForm",
  "YxCode",
];

let formItem = {
  type: PropTypes.oneOf(formType),
  coordinate: ["0-0-0"],
  mutex: PropTypes.func /* 互斥条件 */,
  controlItemParam: {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.any,
    rules: PropTypes.object,
  },
};

YxIncrementForm.propTypes = {
  template: PropTypes.arrayOf(PropTypes.shape(formItem)) /* 自增模版 */,
  // param: PropTypes.shape({
  // }),/* 表单配置参数 */
  operating: PropTypes.shape({}) /* form 配置 buttonList */,
  requestParam: PropTypes.object /* 请求数据接口 */,
  remoteValues: PropTypes.array /* 反序列号数据 */,
  onChange: PropTypes.func /* 自增表单数据更新触发，返回全量更新数据 */,
  // totalRule: String, /* 计算表达式 {key_id*key_id+key_id}*/
  label: PropTypes.string,
  saveType: PropTypes.oneOf(["submit", "change"]) /* 提交方式 */,
  isFormItem: PropTypes.bool /* 是否为表单item项 */,
};
YxIncrementForm.defaultProps = {
  label: "",
  saveType: "submit",
  isFormItem: false,
  remoteValues: [],
};

export default YxIncrementForm;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxIncrementForm/index.js